import { createContext } from "react";
import OrdersStore from './index'

const store = new OrdersStore();
const OrdersStoreContext = createContext<OrdersStore>(store);
export default OrdersStoreContext;
